import React, { useState, useEffect } from "react";
import { Col, Row, Space, Tag, Typography, Empty, Skeleton, Table, Button, Tooltip, Input, Dropdown, Menu, Checkbox, Flex, Select, InputNumber, Form, DatePicker } from 'antd';
import { EditOutlined, DeleteOutlined, FilterOutlined, ArrowLeftOutlined, CloseOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import dayjs from "dayjs";
import moment from 'moment'; // Add this import at the top of your file
import { message, Spin } from 'antd'; // Import for warning messages


import styles from "./reports.module.scss";
import { useNavigate } from "react-router-dom";
import CustomTypography from "../../common/CustomTypography";
import { useSelector, useDispatch } from "react-redux";
import authorization from "../../../utils/auth/authorization";
import { setUploadedAccountDetails } from "../../../store/reducers/slices/updateReport.slice";
import { getRecentAnalyzedReports } from "../../../api/homepage";
import { setHomeDetails, setHomeLoading } from "../../../store/reducers/slices/home.slice";
import { setAllOverviewData } from "../../../store/reducers/slices/overview.slice";
import { basic } from "../../../api/user";
import CustomInput from "../../common/CustomInput";
import { operators } from "ajv/dist/compile/codegen";
import { filter } from "../../../api/filterApi";
import CustomButton from "../../common/CustomButton";
import { PlusOutlined, DownloadOutlined } from "@ant-design/icons";
import { getreport } from "../../../api/reportapi";

import { getReportDetailByReferrenceId } from "../../../api/reportDetails";
import { deleteReport } from "../../../api/deleteReports";
import { filterByName } from "../../../api/filterApi"

const ReportsPage = ({ homeData }) => {
    const { homeDetails: reportsData, homeError, homeLoading: loading } = useSelector(({ home }) => home);
    const { reportDetails, selectedAccountId } = useSelector(
        ({ reportDetails }) => reportDetails
    );
    const [searchText, setSearchText] = useState('');
    const [zentraScoreApplied, setZentraScoreApplied] = useState(false);

    const [selectElement, setSelectElement] = useState();
    const [inputValue, setInputValue] = useState("");
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [lastUpdateFromDate, setlastUpdateFromDate] = useState(null);
    const [lastUpdateToDate, setlastUpdateToDate] = useState(null);
    const [users, setUsers] = useState([]);
    const [selectedFilters, setSelectedFilters] = useState({
        accountStatus: [],
        createdBy: [],
        createdOn: [],
        lastUpdatedBy: [],
        lastUpdatedOn: [],
        zentraScore: [],
        refId: [],
        status: [],
        name: []
    });

    const [filterStates, setFilterStates] = useState({
        accountStatus: [],
        createdBy: [],
        createdOn: [],
        lastUpdatedBy: [],
        lastUpdatedOn: [],
        zentraScore: [],
        refId: [],
        status: [],
        name: []
    });

    const [appliedFilters, setAppliedFilters] = useState({
        accountStatus: [],
        createdBy: [],
        createdOn: [],
        lastUpdatedBy: [],
        lastUpdatedOn: [],
        zentraScore: [],
        refId: [],
        status: [],
        name: []
    });

    const [openKeys, setOpenKeys] = useState([]);

    const handleOpenChange = (keys) => {
        console.log("HANDLE OPEN KEYS", keys);

        setOpenKeys(keys);
    };

    const [form] = Form.useForm();

    const dispatch = useDispatch();

    const user = authorization.getAuthUser();
    console.log("USER REPORT LIST VIEW", user, reportsData);

    const navigate = useNavigate();

    useEffect(() => {
        dispatch(setAllOverviewData({
            overview: {},
        }));
        dispatch(setHomeLoading(true));
        const fetchBasic = async () => {
            const response = await basic()
            setUsers(response);
        }
        const fetchUpdatedStatus = async () => {

            let closeBtnClick = localStorage.getItem('closeBtnClick') || false;
            if (closeBtnClick) {
                reportsData?.reports.map(async (item) => {
                    if (item.reportStatus === 'IN PROGRESS' && (!appliedFilters.accountStatus && !appliedFilters.createdBy && !appliedFilters.name && !appliedFilters.createdOn && !appliedFilters.lastUpdatedBy && !appliedFilters.lastUpdatedOn && !appliedFilters.zentraScore && !appliedFilters.refId && !appliedFilters.status)) {
                        const response = await getRecentAnalyzedReports(0, 25, "desc", "lastUpdationOn", "");
                        dispatch(setHomeDetails(response));
                        dispatch(setHomeLoading(false));
                    }
                })
            }
        }
        fetchBasic();
        fetchUpdatedStatus();
    }, [dispatch, reportsData, appliedFilters]);

    useEffect(() => {
        const savedFilters = localStorage.getItem('filterStates');
        if (savedFilters) {
            setFilterStates(JSON.parse(savedFilters));
        }
    }, []);

    // useEffect(() => {
    //     localStorage.setItem('appliedFilters', JSON.stringify(filterStates));
    // }, [filterStates]);

    const columns = [
        { title: 'Customer Name', dataIndex: 'reportName', key: 'name' },
        { title: 'Reference ID', dataIndex: 'reportId', key: 'refId' },
        {
            title: 'Status',
            // title: (
            //     <>
            //         Status{' '}
            //         <Tooltip title={(<>
            //             <p>Bank Statement file status indicates if the file was parsed successfully or not. Here’s the definition of bank statement file level status displayed in saved Report and corrective action required for unblocking the analysis in case of parsing errors:</p><br />
            //             <p>
            //                 1. <strong>Initialising</strong> - prepration for parsing<br />
            //                 2. <strong>Parsing</strong> - parsing has started<br />
            //                 3. <strong>Parsed</strong> - file parsed successfully<br />
            //                 4. <strong>In review</strong> - file can be parsed but need manual intervention<br />
            //                 5. <strong>Not parsable</strong> - file could not be parsed for some reason.
            //             </p>
            //         </>)}>
            //             <QuestionCircleOutlined style={{ marginLeft: 8, fontSize: '14px', color: '#666666' }} />
            //         </Tooltip>
            //     </>
            // ),
            dataIndex: 'reportStatusDescription',
            key: 'status',
            // render: (text, record) => (
            //     <Tag color={record.reportStatus === 'Completed' ? "#FFF7E6" : "#F0F5FF"} style={{ border: record.reportStatus === 'Completed' ? "1px solid #FFD591" : "1px solid #ADC6FF" }}>
            //         <Typography.Text style={{ color: record.reportStatus === 'Completed' ? "#FA8C16" : "#2F54EB", fontWeight: 500, fontSize: "12px", lineHeight: "20px" }}>
            //             {record.reportStatusDescription}
            //         </Typography.Text>
            //     </Tag>
            // ),

            render: (text, record) => {
                const isCompleted = record.reportStatus === 'Completed';
                const isInProgress = record.reportStatus === 'IN PROGRESS';
                const isFailed = record.reportStatus === 'Failed';

                return (
                    <Tag
                        color={isCompleted ? "#FFF7E6" : (isInProgress ? "#FFF3E0" : (isFailed ? "#FFF1F0" : "#F0F5FF"))}
                        style={{
                            border: isCompleted ? "1px solid #FFD591" : (isInProgress ? "1px solid #FFA726" : (isFailed ? "1px solid #FFCCC7" : "1px solid #ADC6FF"))
                        }}
                    >
                        <Typography.Text
                            style={{
                                color: isCompleted ? "#FA8C16" : (isInProgress ? "#FB8C00" : (isFailed ? "#F5222D" : "#2F54EB")),
                                fontWeight: 500,
                                fontSize: "12px",
                                lineHeight: "20px"
                            }}
                        >
                            {record.reportStatusDescription}
                        </Typography.Text>
                    </Tag>
                );
            }


        },
        {
            title: 'Zentra Score',
            dataIndex: 'precisaScore',
            key: 'precisaScore',
            render: (text, record) => (
                record.precisaScore ? (
                    <Tag color="#F0F5FF" style={{ border: "1px solid #ADC6FF" }}>
                        <Typography.Text style={{ color: "#2F54EB", fontWeight: 500, fontSize: "12px", lineHeight: "20px" }}>
                            {record.precisaScore}
                        </Typography.Text>
                    </Tag>
                ) : (
                    <Tag color="#FFF7E6" style={{ border: "1px solid #FFD591" }}>
                        <Typography.Text style={{ color: "#FA8C16", fontWeight: 500, fontSize: "12px", lineHeight: "20px" }}>
                            -
                        </Typography.Text>
                    </Tag>
                )
            ),
        },
        {
            title: 'Created By',
            key: 'createdOn',
            dataIndex: 'createdOn',
            render: (_, record) => (
                <Space size="middle">
                    <div>
                        {user?.email} <br />
                        {dayjs(record.createdOn).format("DD/MM/YYYY hh:mm:ss A")}
                    </div>
                </Space>
            ),
        },
        {
            title: 'Last Updated By',
            key: 'lastUpdatedBy',
            dataIndex: 'lastUpdatedBy',
            render: (_, record) => (
                <Space size="middle">
                    <div>
                        {user?.email} <br />
                        {dayjs(record.lastUpdatedOn).format("DD/MM/YYYY hh:mm:ss A")}
                    </div>
                </Space>
            ),
        },
        {
            title: 'Action',
            key: 'action',
            render: (_, record) => (
                <Space size="middle">
                    <Tooltip title="Edit">
                        <Button type="link" icon={<EditOutlined />} onClick={(event) => handleEdit(event, record)} > Edit</Button>
                    </Tooltip>
                    {/* <Tooltip title="Delete">
                        <Button type="link" icon={<DeleteOutlined />} onClick={(event) => handleDelete(event, record)} />
                    </Tooltip> */}
                </Space>
            ),
        }
    ];

    const handleFromDateChange = (date) => {
        setFromDate(date);
        if (date && toDate && date.isAfter(toDate, "day")) {
            form.setFieldsValue({ to: null });
            setToDate(null);
        }
    };

    const handleToDateChange = (date) => {
        setToDate(date);
        if (date && fromDate && date.isBefore(fromDate, "day")) {
            form.setFieldsValue({ from: null });
            setFromDate(null);
        }
    };
    const handleLastUpdateFromDateChange = (date) => {
        setlastUpdateFromDate(date);
        if (date && lastUpdateToDate && date.isAfter(lastUpdateToDate, "day")) {
            form.setFieldsValue({ to: null });
            setlastUpdateToDate(null);
        }
    };

    const handleLastUpdateToDateChange = (date) => {
        setlastUpdateToDate(date);
        if (date && lastUpdateFromDate && date.isBefore(lastUpdateFromDate, "day")) {
            form.setFieldsValue({ from: null });
            setlastUpdateFromDate(null);
        }
    };

    const handleEdit = (event, record) => {
        console.log("EDIT REPORT RECORDS::", record);
        event.stopPropagation();
        navigate(`/reports/${record.reportId}/edit`);
    };
    const handleDelete = async (event, record) => {
        event.stopPropagation();
        console.log("DELETE REPORT RECORDS::", record);
        const response = await deleteReport(record?.reportId);
        console.log("DELETE RESPONSE", response);
        dispatch(setHomeDetails(null));

    };

    const handleSearch = (e) => {
        setSearchText(e.target.value.toLowerCase());
    };

    const handleFilterChange = (value, category) => {
        console.log("HANDLE ::>>", value, category);

        setSelectedFilters(prevState => ({
            ...prevState,
            [category]: value,
        }));
    };

    const handleSelect = (value) => {
        setSelectElement(value);

    }



    const handleApply = async (selectedFilterValues) => {
        const zentraScoreKey = "zentraScore";
        const zentraScoreValue = selectedFilterValues[zentraScoreKey];

        // Check if Zentra Score is applied and warn if already applied once
        if (zentraScoreApplied && zentraScoreValue !== undefined && zentraScoreValue !== null) {
            message.warning("You can only apply the Zentra Score filter once.");
            return;
        }

        // Allow reapplying Zentra Score if it has been cleared
        if (!zentraScoreValue) {
            setZentraScoreApplied(false);
        } else {
            setZentraScoreApplied(true); // Mark Zentra Score as applied
        }

        console.log("sdhedk")
        dispatch(setHomeDetails(null));
        const updatedFilters = { ...filterStates };
        console.log("Parameter", selectedFilterValues, updatedFilters);

        setAppliedFilters((prevState) => ({
            ...prevState,
            ...Object.entries(selectedFilterValues).reduce((acc, [key, value]) => {
                console.log("keys", value)
                if ((Array.isArray(value) && value.length === 0) || value === "") {
                    console.log("nothing")
                    return acc; // Skip adding the key if value is empty
                }

                if (key === "reportId") {
                    acc["reportId"] = value; // Keep it simple for the name

                    // acc["reportId"] = value.map(id => `${id}:`).join(';').slice(0, -1);
                } else if (key === "zentraScore" || key === 'createdOn' || key === 'lastUpdatedOn') {
                    acc[key] = value;
                }
                else if (key == "name") {
                    console.log("keyyyyy")
                    acc["reportName"] = value; // Keep it simple for the name
                } else {
                    acc[key] = value;
                }
                return acc;
            }, {}),
        }));

        Object.entries(selectedFilterValues).forEach(([key, value]) => {
            console.log("ZENTRA KEY AND VALUE::>", key, value);
            // if (key === "reportId") {
            //     if (value) {
            //         if (updatedFilters.reportId?.includes(value)) {
            //             updatedFilters.reportId = updatedFilters.reportId.filter(item => item !== value); // Remove unselected value
            //         } else {
            //             updatedFilters.reportId = [...new Set([...(updatedFilters.reportId || []), value])];
            //         }
            //     }
            // }


            if (key === "zentraScore") {
                if (updatedFilters.zentraScore?.includes(value)) {
                    updatedFilters.zentraScore = updatedFilters.zentraScore.filter(item => item !== value); // Remove unselected value
                } else {
                    updatedFilters.zentraScore = [...new Set([...(updatedFilters.zentraScore || []), value])];
                }
            } else if (Array.isArray(value)) {
                updatedFilters[key] = value;
            } else if (Array.isArray(value)) {
                updatedFilters[key] = value;
            } else {
                updatedFilters[key] = value;
            }
        });


        const formattedPayload = Object.entries(updatedFilters).reduce((acc, [key, value]) => {
            if ((Array.isArray(value) && value.length === 0) || value === "") {
                return acc; // Skip adding the key if value is empty
            }

            // if (key === "reportId") {
            //     acc["reportId"] = value.map(id => `${id}:`).join(';').slice(0, -1);
            // } 


            else if (key === "zentraScore" || key === 'createdOn' || key === 'lastUpdatedOn') {
                acc[key] = value;
            } else if (Array.isArray(value)) {
                acc[key] = value.map(item => `${item}:`).join(';').slice(0, -1);
            } else {
                acc[key] = value;
            }
            return acc;
        }, {});



        setFilterStates(updatedFilters);
        localStorage.setItem('filterStates', JSON.stringify(updatedFilters));

        console.log("Formatted Payload:", updatedFilters, formattedPayload);
        const response = await filter(formattedPayload);
        dispatch(setHomeDetails(response));
        // let response = {};
        // console.log("formattedPayload", formattedPayload)
        // if (formattedPayload.name) {
        //     console.log("nameee", formattedPayload.reportName)
        //     response = await filterByName({ reportName: formattedPayload.reportName });
        // } else {
        //     console.log("calll other filter")
        //     response = await filter(formattedPayload);
        // }
        dispatch(setHomeDetails(response));
        // if (selectedFilterValues.name) {
        //     const namePayload = { reportName: selectedFilterValues.name };
        //     const nameResponse = await filterByName(namePayload);
        //     // Merge responses if necessary, or handle separately
        //     dispatch(setHomeDetails({ ...response, nameData: nameResponse }));
        // } else {
        //     dispatch(setHomeDetails(response));
        // }
    };



    const handleRemoveFilter = async (category, value) => {
        setZentraScoreApplied(false);


        dispatch(setHomeDetails(null));
        const updatedFilters = { ...filterStates };
        const updatedSelectedFilters = { ...selectedFilters };

        setAppliedFilters((prevState) => {
            const updatedFilters = { ...prevState };

            if (Array.isArray(updatedFilters[category])) {
                updatedFilters[category] = updatedFilters[category].filter((item) => item !== value);
            }

            // Remove the key if the array is empty
            if (updatedFilters[category]?.length === 0) {
                delete updatedFilters[category];
            }

            return updatedFilters;
        });

        console.log("REMOVING FILTER::>>>", category, value);


        if (Array.isArray(updatedFilters[category]) && (category === 'createdOn' || category === 'lastUpdatedOn')) {
            updatedFilters[category] = [];

            console.log("CLOSE DATA", updatedFilters);

            // Update the selectedFilters state to uncheck the checkbox
            updatedSelectedFilters[category] = [];
        } else if (Array.isArray(updatedFilters[category]) && (category !== 'reportId' || category !== 'zentraScore')) {
            updatedFilters[category] = updatedFilters[category].filter(item => item !== value);

            console.log("CLOSE DATA", updatedFilters);

            // Update the selectedFilters state to uncheck the checkbox
            updatedSelectedFilters[category] = updatedSelectedFilters[category]?.filter(item => item !== value);
        } else {
            delete updatedFilters[category];
            delete updatedSelectedFilters[category];
        }

        setFilterStates(updatedFilters);
        setSelectedFilters(updatedSelectedFilters);
        localStorage.setItem('filterStates', JSON.stringify(updatedFilters));
        // Update your API payload here
        const formattedPayload = Object.entries(updatedFilters).reduce((acc, [key, value]) => {

            if ((Array.isArray(value) && value.length === 0) || value === "") {
                return acc; // Skip adding the key if value is empty
            }

            else if (key === "zentraScore" || key === 'createdOn' || key === 'lastUpdatedOn') {
                acc[key] = value;
            } else if (Array.isArray(value)) {
                acc[key] = value.map(item => `${item}:`).join(';').slice(0, -1);
            } else {
                acc[key] = value;
            }
            return acc;
        }, {});

        console.log("Updated Payload after Removal:", formattedPayload);
        const response = await filter(formattedPayload);
        dispatch(setHomeDetails(response));

    };


    const getLabel = (key, value) => {

        if (Array.isArray(value) && key === 'createdOn') {
            return `${key}: From ${value[0]?.date} To ${value[1]?.date}`;
        } else if (Array.isArray(value) && key === 'lastUpdatedOn') {
            return `${key}: From ${value[0]?.date} To ${value[1]?.date}`;
        } else if (Array.isArray(value) && key === 'zentraScore') {
            value.forEach((item) => {
                return `zentraScore ${item?.operation} ${item?.score}`;
            })
        } else {
            return `${key}: ${value}`;
        }

    }

    const renderTags = () => {
        return Object.entries(filterStates).map(([category, values]) => {
            if (Array.isArray(values) && category === 'zentraScore') {
                console.log("TAG VALUES ::>>", category, values);

                return values.map((value, index) => (
                    <Tag
                        key={`${category}-${value}-${index}`}
                        closable
                        onClose={() => handleRemoveFilter(category, value)}
                    >
                        <Typography.Text style={{ fontWeight: 500, fontSize: "12px", lineHeight: "20px" }}>
                            {`${category}: ${value?.operation} ${value?.score}`}
                        </Typography.Text>
                    </Tag>
                ));
            } else if (Array.isArray(values) && values.length > 1 && category === 'createdOn') {
                console.log("TAG VALUES ::>>", category, values);

                return (
                    <Tag
                        key={category}
                        closable
                        onClose={() => handleRemoveFilter(category, values)}
                    >
                        <Typography.Text style={{ fontWeight: 500, fontSize: "12px", lineHeight: "20px" }}>
                            {`${category}: From ${values[0]?.date} To ${values[1]?.date}`}
                        </Typography.Text>
                    </Tag>
                );
            }
            else if (category === "reportName") {
                return (
                    <Tag
                        key={category}
                        closable
                        onClose={() => handleRemoveFilter(category, values)}
                    >
                        <Typography.Text style={{ fontWeight: 500, fontSize: "12px", lineHeight: "20px" }}>
                            {`Name: ${values}`}
                        </Typography.Text>
                    </Tag>
                );
            }
            else if (Array.isArray(values) && values.length > 1 && category === 'lastUpdatedOn') {
                console.log("TAG VALUES ::>>", category, values);

                return (
                    <Tag
                        key={category}
                        closable
                        onClose={() => handleRemoveFilter(category, values)}
                    >
                        <Typography.Text style={{ fontWeight: 500, fontSize: "12px", lineHeight: "20px" }}>
                            {`${category}: From ${values[0]?.date} To ${values[1]?.date}`}
                        </Typography.Text>
                    </Tag>
                );
            } else if (Array.isArray(values)) {
                console.log("TAG VALUES ::>>", category, values);

                return values.map((value, index) => (
                    <Tag
                        key={`${category}-${value}-${index}`}
                        closable
                        onClose={() => handleRemoveFilter(category, value)}
                    >
                        <Typography.Text style={{ fontWeight: 500, fontSize: "12px", lineHeight: "20px" }}>
                            {`${category}: ${value}`}
                        </Typography.Text>
                    </Tag>
                ));
            } else {
                return (
                    <Tag
                        key={category}
                        closable
                        onClose={() => handleRemoveFilter(category, values)}
                    // icon={<CloseOutlined />}
                    >
                        {`${category}: ${values}`}
                    </Tag>
                );
            }
        });
    };
    const handleClick = async () => {
        try {
            const data = await getreport();
            console.log('Report List:', data);
            // Handle the report list data as needed (e.g., display or save)
        } catch (error) {
            console.error('Error fetching report list:', error.message || error);
        }
    };
    const filteredReports = reportsData?.reports.filter((report) =>
        report.reportName.toLowerCase().includes(searchText.toLowerCase())
    );

    console.log("Filter data", filteredReports, selectedFilters, users, selectElement);

    const provinceData = ['', '>', '>=', '=', '!=', '<', '<='];


    const filterMenu = (
        <Menu openKeys={openKeys} onOpenChange={handleOpenChange}>
            <Menu.SubMenu key="accountStatus" title="Account Status">
                <Menu.ItemGroup>
                    <Checkbox.Group
                        value={selectedFilters.accountStatus}
                        onChange={(value) => handleFilterChange(value, 'accountStatus')}
                    >
                        <Space direction="vertical">
                            <Space direction='horizontal'>
                                <ArrowLeftOutlined />
                                <Typography.Text className="report-label-text">Account Status</Typography.Text>
                            </Space>
                            {['Analysed', 'In Review', 'On Hold', 'No Transaction', 'Initializing'].map((status) => (
                                <Checkbox
                                    key={status}
                                    value={status}
                                    disabled={appliedFilters.accountStatus?.includes(status)}
                                >
                                    {status}
                                </Checkbox>
                            ))}
                            <Space style={{ marginLeft: '120px' }}>
                                <Button type="primary" onClick={() => handleApply({ accountStatus: selectedFilters.accountStatus })}>Apply</Button>
                            </Space>
                        </Space>
                    </Checkbox.Group>
                </Menu.ItemGroup>
            </Menu.SubMenu>

            {/* <Menu.SubMenu key="createdBy" title="Created By">
                <Menu.ItemGroup>
                    <Checkbox.Group 
                        value={selectedFilters.createdBy} 
                        onChange={(value) => handleFilterChange(value, 'createdBy')}
                    >
                        <Space direction="vertical">
                            <Space direction='horizontal'>
                                <ArrowLeftOutlined />
                                <Typography.Text className="report-label-text">Created By</Typography.Text>
                            </Space>
                            {users.map((item) => (<Checkbox value={item?.email} disabled={appliedFilters.lastUpdatedBy?.includes(item?.email)}>{item?.firstName}</Checkbox>))}
                            <Space style={{marginLeft: '120px'}}>
                                <Button type="primary" onClick={() => handleApply({createdBy: selectedFilters.createdBy})}>Apply</Button>
                            </Space>
                        </Space>
                    </Checkbox.Group>
                </Menu.ItemGroup>
            </Menu.SubMenu> */}

            <Menu.SubMenu key="createdOn" title="Created On" disabled={filterStates.createdOn?.length > 0 ? true : false}>
                <Menu.ItemGroup>
                    <Space style={{ marginBottom: 10 }}>
                        <Space direction='horizontal'>
                            <ArrowLeftOutlined />
                            <Typography.Text className="report-label-text">Created On</Typography.Text>
                        </Space>
                    </Space>
                    <Form
                        name="basic"
                        initialValues={{ remember: true, }}
                        onFinish={(values) => {
                            console.log("VALUES DETERMINING:>>>",);

                            const formattedData = {
                                createdOn: [
                                    { date: values.from.format("YYYY-MM-DD"), operation: ">=" },
                                    { date: values.to.format("YYYY-MM-DD"), operation: "<=" },
                                ],
                            };
                            handleApply(formattedData);
                            setOpenKeys([]);
                        }}
                        autoComplete="off"
                    >
                        <Form.Item
                            name="from"
                            rules={[{ required: true, message: "Please select a start date!" }]}
                        >
                            <DatePicker
                                placeholder="From"
                                disabledDate={(current) => toDate && current && current.isAfter(toDate, "day") ||
                                    (current && current.isAfter(moment(), "day"))}
                                onChange={handleFromDateChange}
                                style={{
                                    width: '100%',
                                }}
                            />
                        </Form.Item>
                        <Form.Item
                            name="to"
                            rules={[{ required: true, message: "Please select an end date!" }]}
                        >
                            <DatePicker
                                placeholder="To"
                                disabledDate={(current) => fromDate && current && current.isBefore(fromDate, "day") ||
                                    (current && current.isAfter(moment(), "day"))}
                                onChange={handleToDateChange}
                                style={{
                                    width: '100%',
                                }}
                            />
                        </Form.Item>
                        <Space style={{ marginLeft: '120px' }}>
                            <Button type="primary" htmlType="submit">Apply</Button>
                        </Space>
                    </Form>
                </Menu.ItemGroup>
            </Menu.SubMenu>

            {/* <Menu.SubMenu key="lastUpdatedBy" title="Last Updated By">
                <Menu.ItemGroup>
                    <Checkbox.Group 
                        value={selectedFilters.lastUpdatedBy} 
                        onChange={(value) => handleFilterChange(value, 'lastUpdatedBy')}
                    >
                        <Space direction="vertical">
                            <Space direction='horizontal'>
                                <ArrowLeftOutlined />
                                <Typography.Text className="report-label-text">Last Updated By</Typography.Text>
                            </Space>
                            {users.map((item) => (<Checkbox value={item?.email} disabled={appliedFilters.lastUpdatedBy?.includes(item?.email)}>{item?.firstName}</Checkbox>))}
                            <Space style={{marginLeft: '120px'}}>
                                <Button type="primary" onClick={() => handleApply({lastUpdatedBy: selectedFilters.lastUpdatedBy})}>Apply</Button>
                            </Space>
                        </Space>
                        
                    </Checkbox.Group>
                </Menu.ItemGroup>
            </Menu.SubMenu> */}

            <Menu.SubMenu key="lastUpdatedOn" title="Last Updated On" disabled={filterStates.lastUpdatedOn?.length > 0 ? true : false}>
                <Menu.ItemGroup>
                    <Space style={{ marginBottom: 10 }}>
                        <Space direction='horizontal'>
                            <ArrowLeftOutlined />
                            <Typography.Text className="report-label-text">Last Updated On</Typography.Text>
                        </Space>
                    </Space>
                    <Form
                        name="basic"
                        initialValues={{ remember: true, }}
                        onFinish={(values) => {
                            const formattedData = {
                                lastUpdatedOn: [
                                    { date: values.lastUpdateFrom.format("YYYY-MM-DD"), operation: ">=" },
                                    { date: values.lastUpdateTo.format("YYYY-MM-DD"), operation: "<=" },
                                ],
                            };
                            handleApply(formattedData);
                            setOpenKeys([]);
                        }}

                        autoComplete="off"
                    >
                        <Form.Item
                            name="lastUpdateFrom"
                            rules={[{ required: true, message: "Please select a start date!" }]}
                        >
                            <DatePicker
                                placeholder="From"
                                disabledDate={(current) => lastUpdateToDate && current && current.isAfter(lastUpdateToDate, "day") ||
                                    (current && current.isAfter(moment(), "day"))}
                                onChange={handleLastUpdateFromDateChange}
                                style={{
                                    width: '100%',
                                }}
                            />
                        </Form.Item>
                        <Form.Item
                            name="lastUpdateTo"
                            rules={[{ required: true, message: "Please select an end date!" }]}
                        >
                            <DatePicker
                                placeholder="To"
                                disabledDate={(current) => lastUpdateFromDate && current && current.isBefore(lastUpdateFromDate, "day") ||
                                    (current && current.isAfter(moment(), "day"))}
                                onChange={handleLastUpdateToDateChange}
                                style={{
                                    width: '100%',
                                }}
                            />
                        </Form.Item>
                        <Space style={{ marginLeft: '120px' }}>
                            <Button type="primary" htmlType="submit">Apply</Button>
                        </Space>
                    </Form>
                </Menu.ItemGroup>
            </Menu.SubMenu>

            <Menu.SubMenu key="zentraScore" title="Zentra Score" >
                <Menu.ItemGroup>
                    <Space style={{ marginBottom: 10 }}>
                        <Space direction='horizontal'>
                            <ArrowLeftOutlined />
                            <Typography.Text className="report-label-text">Zentra Score</Typography.Text>
                        </Space>
                    </Space>
                    <Form name="basic" initialValues={{ remember: true, }} onFinish={() => handleApply({ zentraScore: { score: `${inputValue}`, operation: selectElement, } })} autoComplete="off" >
                        <Form.Item name="operator"
                            rules={[
                                {
                                    required: true,
                                    // message: 'Please input your username!',
                                },
                            ]}
                        >
                            <Select
                                defaultValue={provinceData[0]}
                                onChange={handleSelect}
                                options={provinceData.map((province) => ({
                                    label: province,
                                    value: province,
                                }))}
                            />
                        </Form.Item>

                        <Form.Item name="score"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input your password!',
                                },
                            ]}
                        >
                            <InputNumber
                                placeholder="Zentra Score"
                                value={inputValue}
                                onChange={(e) => setInputValue(e)}
                                style={{
                                    width: '100%',
                                }}
                            />
                        </Form.Item>
                        <Space style={{ marginLeft: '120px' }}>
                            <Button type="primary" htmlType="submit">Apply</Button>
                        </Space>
                    </Form>
                </Menu.ItemGroup>
            </Menu.SubMenu>

            {/* <Menu.SubMenu key="reportId" title="Reference ID">
                <Menu.ItemGroup>
                    <Space style={{ marginBottom: 10 }}>
                        <Space direction='horizontal'>
                            <ArrowLeftOutlined />
                            <Typography.Text className="report-label-text">Reference ID</Typography.Text>
                        </Space>
                    </Space>
                    <Form form={form} name="basic" initialValues={{ remember: true, }} onFinish={(value) => handleApply(value)} autoComplete="off" >
                        <Form.Item name="reportId"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input your Reference ID!',
                                },
                            ]}
                        >
                            <Input
                                placeholder="Enter Reference ID"
                            />
                        </Form.Item>

                        <Space style={{ marginLeft: '120px' }}>
                            <Button type="primary" htmlType="submit">Apply</Button>
                        </Space>
                    </Form>
                </Menu.ItemGroup>
            </Menu.SubMenu> */}


            <Menu.SubMenu key="reportId" title="Reference ID">
                <Menu.ItemGroup>
                    <Space style={{ marginBottom: 10 }}>
                        <Space direction="horizontal">
                            <ArrowLeftOutlined />
                            <Typography.Text className="report-label-text">Reference ID</Typography.Text>
                        </Space>
                    </Space>

                    {/* Form for the Name filter */}
                    <Form
                        form={form}

                        name="nameFilter"
                        initialValues={{ reportId: selectedFilters.refId || '' }} // Set initial value to selectedFilters.name
                        onFinish={(value) => {
                            console.log("Form Value:", value); // Log the form value
                            handleApply({ reportId: selectedFilters.refId }); // Pass the value to the handleApply function
                        }}
                        autoComplete="off"
                    >
                        <Form.Item
                            name="reportId"
                            rules={[{ required: true, message: 'Please input the Reference ID to filter!' }]}
                        >
                            <Input
                                placeholder="Enter Reference ID"
                                allowClear
                                value={"sonal"} // Bind input value to selectedFilters.name
                                onChange={(e) => {
                                    setSelectedFilters({ ...selectedFilters, refId: e.target.value }); // Update the selectedFilters object on input change
                                }}
                            />
                        </Form.Item>

                        {/* Submit Button for the form */}
                        <Space style={{ marginLeft: '120px' }}>
                            {/* <Button type="primary" htmlType="submit">Apply</Button> Button triggers form submit */}
                            <Button type="primary" onClick={() => handleApply({ reportId: selectedFilters.refId })}>Apply</Button>

                        </Space>
                    </Form>
                </Menu.ItemGroup>
            </Menu.SubMenu>

            <Menu.SubMenu key="status" title="Status">
                <Menu.ItemGroup>
                    <Checkbox.Group
                        value={selectedFilters.status}
                        onChange={(value) => handleFilterChange(value, 'status')}
                    >
                        <Space direction="vertical">
                            <Space direction='horizontal'>
                                <ArrowLeftOutlined />
                                <Typography.Text className="report-label-text">Report Status</Typography.Text>
                            </Space>

                            {['ANALYSED', 'IN PROGRESS', 'ANALYSIS FAILED'].map((status) => (
                                <Checkbox
                                    key={status}
                                    value={status}
                                    disabled={appliedFilters.status?.includes(status)}
                                >
                                    {status}
                                </Checkbox>
                            ))}
                            <Space style={{ marginLeft: '120px' }}>
                                <Button type="primary" onClick={() => handleApply({ reportStatus: selectedFilters.status })}>Apply</Button>
                            </Space>
                        </Space>
                    </Checkbox.Group>
                </Menu.ItemGroup>
            </Menu.SubMenu>
            {/* <Menu.SubMenu key="reportName" title="Name">
                <Menu.ItemGroup>
                    <Space style={{ marginBottom: 10 }}>
                        <Space direction='horizontal'>
                            <ArrowLeftOutlined />
                            <Typography.Text className="report-label-text">Reference ID</Typography.Text>
                        </Space>
                    </Space>
                    <Form form={form} name="basic" initialValues={{ remember: true, }} onFinish={(value) => handleApply(selectedFilters.name)} autoComplete="off" >
                        <Form.Item name="reportName"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input your name',
                                },
                            ]}
                        >
                            <Input
                                placeholder="Enter name"
                            />
                        </Form.Item>

                        <Space style={{ marginLeft: '120px' }}>
                            <Button type="primary" htmlType="submit">Apply</Button>
                        </Space>
                    </Form>
                </Menu.ItemGroup>
            </Menu.SubMenu> */}

            <Menu.SubMenu key="reportName" title="Name">
                <Menu.ItemGroup>
                    <Space style={{ marginBottom: 10 }}>
                        <Space direction="horizontal">
                            <ArrowLeftOutlined />
                            <Typography.Text className="report-label-text">Name</Typography.Text>
                        </Space>
                    </Space>

                    {/* Form for the Name filter */}
                    <Form
                        form={form}

                        name="nameFilter"
                        initialValues={{ reportName: selectedFilters.name || '' }} // Set initial value to selectedFilters.name
                        onFinish={(value) => {
                            console.log("Form Value:", value); // Log the form value
                            handleApply({ reportName: selectedFilters.name }); // Pass the value to the handleApply function
                        }}
                        autoComplete="off"
                    >
                        <Form.Item
                            name="reportName"
                            rules={[{ required: true, message: 'Please input the name to filter!' }]}
                        >
                            <Input
                                placeholder="Enter name"
                                allowClear
                                value={"sonal"} // Bind input value to selectedFilters.name
                                onChange={(e) => {
                                    setSelectedFilters({ ...selectedFilters, name: e.target.value }); // Update the selectedFilters object on input change
                                }}
                            />
                        </Form.Item>

                        {/* Submit Button for the form */}
                        <Space style={{ marginLeft: '120px' }}>
                            {/* <Button type="primary" htmlType="submit">Apply</Button> Button triggers form submit */}
                            <Button type="primary" onClick={() => handleApply({ reportName: selectedFilters.name })}>Apply</Button>

                        </Space>
                    </Form>
                </Menu.ItemGroup>
            </Menu.SubMenu>


        </Menu>
    );

    const getReportDetails = async (reportId) => {
        const response = await getReportDetailByReferrenceId(reportId);
        const hasNoTransactions = response?.reportAccounts?.some(item => item.account.status === "NO TRANSACTIONS");
        let onLengthArr = response?.reportAccounts.length === 1 ? true : false;
        console.log("GET REPORT DETAILS", hasNoTransactions, onLengthArr);

        if (hasNoTransactions === true && onLengthArr === true) {
            return true
        } else {
            return false
        }
    }

    return (
        <div>
            <Row gutter={[16, 16]}>
                <Col xs={24} sm={12}>
                    <CustomTypography type={"title"} level={3} className={styles.reportHeader}>
                        Turn <span className={styles.reportHeaderDark}>Data</span> Into <span className={styles.reportHeaderDark}>Decisions</span>
                    </CustomTypography>
                    <CustomTypography className={styles.reportSubHeader} type={"text"}>
                        Zentra automates bank statement analysis, transforming complex financial data into clear, actionable reports in minutes.
                    </CustomTypography>
                </Col>

                <Col xs={24}>
                    <Row justify="space-between" align="middle" style={{ marginBottom: "16px" }}>
                        <CustomTypography type="title" className={styles.reportAnalyzedHeader} level={4}>
                            Recent Analyzed Reports
                        </CustomTypography>

                        <Space size="middle">
                            <Input.Search
                                placeholder="Search Customers"
                                value={searchText}
                                onChange={handleSearch}
                                style={{ width: 400 }}
                            />
                            <Dropdown overlay={filterMenu} trigger={['click']}>
                                <Button icon={<FilterOutlined />} />
                            </Dropdown>
                            <CustomButton icon={<DownloadOutlined />} onClick={handleClick}>
                                Report List
                            </CustomButton>
                        </Space>
                    </Row>

                    {/* Render Tags for Applied Filters */}
                    <Row style={{ marginBottom: "16px" }}>
                        <Space wrap>
                            {renderTags()}
                        </Space>
                    </Row>

                    {reportsData ? (
                        <Table
                            columns={columns}
                            dataSource={filteredReports}
                            pagination={false}
                            scroll={{ x: 'max-content' }}
                            style={{ width: '100%' }}
                            className='table-border'
                            onRow={(record) => ({
                                onClick: async () => {
                                    let isNavigateToEdit = await getReportDetails(record.reportId);
                                    console.log("ON CLICK OF TABLE ROW", record, await getReportDetails(record.reportId));

                                    if (isNavigateToEdit) {
                                        navigate(`/reports/${record.reportId}/edit`);
                                    } else {
                                        navigate(`/reports/${record.reportId}`);
                                    }

                                },
                                style: { cursor: 'pointer' },
                            })}
                        />
                    ) : loading ? (
                        // <Row gutter={[16, 16]} justify={"start"} style={{ marginTop: "16px" }}>
                        //     {[1, 2, 3, 4].map((item, index) => (
                        //         <Col xs={24} sm={12} md={8} lg={6} xl={6} xxl={4} key={index}>
                        //             <Skeleton active />
                        //         </Col>
                        //     ))}
                        // </Row>
                        <Row justify="center" align="middle" style={{ marginTop: "16px", minHeight: "200px" }}>
                            <Spin size="large" tip="Loading..." />
                        </Row>
                    ) : (
                        <div style={{ paddingTop: "24px" }}>
                            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Your analyzed reports will show here." />
                        </div>
                    )}
                </Col>
            </Row>
        </div>
    );
};

export default ReportsPage;
